// Route tree definition
import { rootRoute } from './routes/__root'
import { indexRoute } from './routes/index'
import { gamesRoute } from './routes/games'
import { aboutRoute } from './routes/about'
import { contactRoute } from './routes/contact'

export const routeTree = rootRoute.addChildren([
  indexRoute,
  gamesRoute,
  aboutRoute,
  contactRoute,
])
